import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {Card, CardContent} from '@mui/material';
import {COLORS} from '@/utils/constants';
import {getDefaultPieFormatting} from '../../charts/pie';

interface Props {
	baseline: any[];
}

const QUESTIONS = [
	'question73',
	'question72',
	'question71',
	'question70',
	'question69',
	'question68',
	'question67',
	'question66',
	'question65',
	'question64',
	'question63',
	'question14',
];

const MainReasonOfFailure = ({baseline}: Props) => {
	const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
	const [options, setOptions] = useState<Highcharts.Options>();

	const calculateSubmissions = () => {
		let businessModel = 0;
		let requestedAmount = 0;
		let teamSkills = 0;
		let dontKnow = 0;

		baseline.forEach((submission: any) => {
			QUESTIONS.forEach((question: string) => {
				if (submission[question] === 'Item 1') {
					businessModel += 1;
				} else if (submission[question] === 'Item 2') {
					requestedAmount += 1;
				} else if (submission[question] === 'Item 3') {
					teamSkills += 1;
				} else if (submission[question] === 'Item 4') {
					dontKnow += 1;
				}
			})
		})

		const data = [
			{
				name: 'Issues related to the business model',
				y: businessModel,
				color: COLORS.blue,
			},
			{
				name: 'The requested amount was too high',
				y: requestedAmount,
				color: COLORS.orange,
			},
			{
				name: 'The skills of the team were not strong enough',
				y: teamSkills,
				color: COLORS.gray,
			},
			{
				name: 'I don\'t know',
				y: dontKnow,
				color: COLORS.yellow,
			},
		];
		const title = 'KPI: Main reason of failure in obtaining the funds';
		const dashboardOptions: any = getDefaultPieFormatting(title, data);

		setOptions(dashboardOptions);
	};

	useEffect(() => {
		calculateSubmissions();
	}, []);

	return (
		<Card className='chart-container'>
			<CardContent>
				{options && (
					<HighchartsReact
						highcharts={Highcharts}
						options={options}
						ref={chartComponentRef}
					/>
				)}
			</CardContent>
		</Card>
	);
};

export default MainReasonOfFailure;
